import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';

//material core
import Button from '@material-ui/core/Button';

//material icons
import MyLocationIcon from '@material-ui/icons/MyLocation';

import L from 'leaflet';

const useStyles = makeStyles((theme) => ({
  //button
  button: {
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#f4f4f4',
    },
    position: 'absolute',
    right: 0,
    top: 120,
    float: 'right',
    paddingLeft: 5,
    paddingRight: 5,
    marginRight: 10,
    minWidth: 1,
    borderRadius: '5px',
  },
}));

const Center = (props) => {
  const classes = useStyles();

  const {mapRef, state} = props;
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (mapRef) {
      setMap(mapRef.current.leafletElement);
    }
  }, [mapRef]);

  const onCenter = () => {
    map.setZoom(state.zoom);
    setTimeout(() => {
      map.panTo(new L.LatLng(state.lat, state.lng));
    }, 300);
  };

  return (
    <div>
      <Button variant="contained" color="default" size="small" className={classes.button} onClick={onCenter}>
        <MyLocationIcon style={{fontSize: 25}} />
      </Button>
    </div>
  );
};

export default Center;
